module.exports = __webpack_public_path__ + "img/home-banner.4ddfa2f0.webp";